import sanitize from 'sanitize-filename';

export const getDLCImageSrc = (dlc) => {
    return `/assets/images/${sanitize(dlc.replaceAll(' ', '_'))}.png`;
};
